import type { AdminRole } from '@/lib/api-admin';

/**
 * QA-628 비즈니스 문의 권한(partner-service 와 같음).
 * 목록·상세 열람 = 관리자 역할 8종 전원, 처리 상태·메모 저장·메일 재발송 = AUDITOR 제외 7종.
 * 수신 설정 조회 = SUPER_ADMIN·OPS_ADMIN·AUDITOR, 저장 = SUPER_ADMIN·OPS_ADMIN.
 */
export const BUSINESS_INQUIRY_READ_ROLES: ReadonlyArray<AdminRole> = [
  'SUPER_ADMIN',
  'OPS_ADMIN',
  'CS_AGENT',
  'MD_MANAGER',
  'FULFILLMENT_AGENT',
  'PICKUP_AGENT',
  'SETTLEMENT_AGENT',
  'AUDITOR',
];

export const BUSINESS_INQUIRY_WRITE_ROLES: ReadonlyArray<AdminRole> = BUSINESS_INQUIRY_READ_ROLES.filter(
  (r) => r !== 'AUDITOR',
);

export const BUSINESS_INQUIRY_RECIPIENT_READ_ROLES: ReadonlyArray<AdminRole> = ['SUPER_ADMIN', 'OPS_ADMIN', 'AUDITOR'];
export const BUSINESS_INQUIRY_RECIPIENT_WRITE_ROLES: ReadonlyArray<AdminRole> = ['SUPER_ADMIN', 'OPS_ADMIN'];
